import { createAction } from 'redux-actions';

export const REPLACE_VIDEO_ACTION_TYPES = {
  videoFooter: {
    replaceItem: {
      clicked: '[Video Footer Replace Item] clicked',
    },
  },
  replaceVideoModal: {
    closed: '[Replace Video Modal] closed',
  },
  replaceVideo: {
    initiated: '[Replace Video Modal] replace video initiated',
    fulfilled: '[Replace Video Modal] replace video fulfilled',
    failed: '[Replace Video Modal] replace video failed',
  },
} as const;

export const replaceVideoActions = {
  videoFooter: {
    replaceItem: {
      clicked: createAction<string>(
        REPLACE_VIDEO_ACTION_TYPES.videoFooter.replaceItem.clicked
      ),
    },
  },
  replaceVideoModal: {
    closed: createAction(REPLACE_VIDEO_ACTION_TYPES.replaceVideoModal.closed),
  },
  replaceVideo: {
    initiated: createAction<File>(
      REPLACE_VIDEO_ACTION_TYPES.replaceVideo.initiated
    ),
    fulfilled: createAction(REPLACE_VIDEO_ACTION_TYPES.replaceVideo.fulfilled),
    failed: createAction(REPLACE_VIDEO_ACTION_TYPES.replaceVideo.failed),
  },
};
